// export const loadTwitterScript = () => {
//   return new Promise((resolve, reject) => {
//     if (window.twttr && window.twttr.widgets) {
//       resolve(true);
//       return;
//     }
//     const script = document.createElement('script');
//     script.src = 'https://platform.twitter.com/widgets.js';
//     script.onload = () => {
//       setTimeout(() => {
//         if (window.twttr && window.twttr.widgets) {
//           resolve(true);
//         } else {
//           reject(new Error('Twitter widgets script loaded, but window.twttr.widgets is undefined.'));
//         }
//       }, 100);
//     };
//     script.onerror = () => reject(new Error('Failed to load Twitter script'));
//     document.head.appendChild(script);
//   });
// };

const TWITTER_SCRIPT_ID = 'twitterScript';
const TWITTER_SCRIPT_SRC = 'https://platform.twitter.com/widgets.js';

let twitterScriptPromise = null;

const waitForTwitterWidgets = (resolve, reject) => {
  let attempts = 0;

  const checkWidgets = () => {
    if (window.twttr?.widgets) {
      resolve(window.twttr);
      return;
    }

    attempts += 1;

    if (attempts >= 50) {
      reject(
        new Error(
          'Twitter widgets script loaded, but window.twttr.widgets is unavailable.'
        )
      );
      return;
    }

    window.setTimeout(checkWidgets, 100);
  };

  checkWidgets();
};

export const loadTwitterScript = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.reject(
      new Error('Twitter widgets can only be loaded in a browser.')
    );
  }

  if (window.twttr?.widgets) {
    return Promise.resolve(window.twttr);
  }

  if (twitterScriptPromise) {
    return twitterScriptPromise;
  }

  twitterScriptPromise = new Promise((resolve, reject) => {
    const existingScript =
      document.getElementById(TWITTER_SCRIPT_ID) ||
      document.querySelector(`script[src="${TWITTER_SCRIPT_SRC}"]`);

    if (existingScript) {
      existingScript.addEventListener(
        'error',
        () => reject(new Error('Failed to load Twitter widgets script.')),
        { once: true }
      );

      waitForTwitterWidgets(resolve, reject);
      return;
    }

    const script = document.createElement('script');
    script.src = TWITTER_SCRIPT_SRC;
    script.async = true;
    script.id = TWITTER_SCRIPT_ID;
    script.onload = () => waitForTwitterWidgets(resolve, reject);
    script.onerror = () =>
      reject(new Error('Failed to load Twitter widgets script.'));

    document.head.appendChild(script);
  }).catch((error) => {
    // Autorise une nouvelle tentative après un véritable échec de chargement.
    twitterScriptPromise = null;
    throw error;
  });

  return twitterScriptPromise;
};
